// opervex-frontend/src/components/CustomInput/customCurrency.js

import React from "react";
import { Form } from "react-bootstrap";
import { NumericFormat } from "react-number-format";

const customCurrency = ({ value, onChange, label, hidden, disabled, name, showDisabled, decimal }) => {
  return (
    <Form.Group hidden={hidden}>
      {label && <Form.Label>{label}</Form.Label>}
      {!showDisabled && disabled ? (
        <div>
          R${" "}
          {new Intl.NumberFormat("pt-BR", {
            minimumFractionDigits: decimal ?? 2,
            maximumFractionDigits: decimal ?? 2,
          }).format(value)}
        </div>
      ) : (
        <NumericFormat
          value={value}
          onValueChange={(values) => onChange(values.floatValue)}
          thousandSeparator="."
          decimalSeparator=","
          size="sm"
          prefix="R$ "
          decimalScale={decimal ?? 2}
          fixedDecimalScale
          name={name}
          hidden={hidden}
          disabled={disabled}
          customInput={Form.Control}
        />
      )}
    </Form.Group>
  );
};

export default customCurrency;
